// src/pages/Enseignants/ListingAdherents/components/GroupHeader.jsx
import React from "react";

const GroupHeader = ({ groupName, count = 0 }) => {
  return (
    <div className="py-3">
      <h3 className="inline-flex items-center gap-3 text-base sm:text-lg font-medium bg-slate-900 text-white px-4 py-2 rounded-xl">
        <span>Groupe {groupName}</span>
        <span className="bg-primary text-white text-xs sm:text-sm font-semibold px-2.5 py-0.5 rounded-full">
          {count}
        </span>
      </h3>
    </div>
  );
};

export default GroupHeader;
